module.exports = "/_next/static/images/yellowgold-277f35e896006e6838499f6777a6f152.png";